import { API_BASE_URLS } from "../config/api.config";

const BASE_PATH = "/LAAPTracker";

const getBackendUrl = () => {
  const baseUrl = API_BASE_URLS.backend || "";
  return baseUrl.replace(/\/$/, "");
};

const buildLookupUrl = (path = "") => {
  return `${getBackendUrl()}${BASE_PATH}${path}`;
};

export const LAAP_ENDPOINTS = {
  LOOKUP: buildLookupUrl("/lookup"),
  GET_RECORDS: (userId, roleId) =>
    buildLookupUrl(`/GetLAAPTrackerRecordsAsync/${userId}/${roleId}`),
  SAVE_RECORD: buildLookupUrl("/SaveLAAPTrackerAsync"),
  UPDATE_RECORD: buildLookupUrl("/UpdateLAAPTrackerAsync"),
  DELETE_RECORD: (recordId) =>
    buildLookupUrl(`/DeleteLAAPTrackerAsync/${recordId}`),
};

export default LAAP_ENDPOINTS;
